import apiRequest from './index'

export default {
  path: '/v1/inspection_estimate_price',
  // post (conditions) {
  //   return apiRequest.post(this.path, { ...conditions })
  // }
  async post (conditions, appVersionHeader) {
    await window.callNativeHTTPX()
    return apiRequest.post(this.path, { ...conditions }, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
        'X-CLS-App-Version': appVersionHeader
      }
    })
  }
}
